import styles from "./PageTypeC.module.css";

const PageTypeC = ({title, text1, text2, text3, imageLeft, imageCenter, imageRight}) => {
    return (
        <main className={styles.main}>
            <div className={styles.wrapper}>
                <h1 className={styles.title}>{title}</h1>
                <div className={styles.contentWrapper}>
                    <div className={styles.block}>
                        <p className={styles.text}>{text1}</p>
                        <div className={styles.divImage}>
                            <img className={styles.imageRounded} alt="" src={imageLeft}/>
                        </div>
                    </div>
                    <div className={styles.block}>
                        <p className={styles.text}>{text2}</p>
                        <div className={styles.divImage}>
                            <img className={styles.imageRounded} alt="" src={imageCenter}/>
                        </div>
                    </div>
                    <div className={styles.block}>
                        <p className={styles.text}>{text3}</p>
                        <div className={styles.divImage}>
                            <img className={styles.imageRounded} alt="" src={imageRight}/>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default PageTypeC;
